import { Link } from 'react-router-dom';
import type { Comic } from '@/types/comic';
import { categoryName, formatCount } from '@/utils/comic';

interface ComicCardProps {
  comic: Comic;
  showDescription?: boolean;
}

export default function ComicCard({ comic, showDescription = false }: ComicCardProps) {
  return (
    <Link
      to={`/detail/${comic.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-colors duration-300 hover:border-primary-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={comic.cover}
          alt={`${comic.title} 漫画封面`}
          title={`${comic.title} 韩漫在线阅读`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 rounded-md bg-primary-600/90 px-2 py-0.5 text-[11px] font-medium text-background-50">
          {comic.status}
        </span>
        <span className="absolute bottom-2 right-2 flex items-center gap-1 rounded-md bg-foreground-950/60 px-2 py-0.5 text-[11px] text-background-50">
          <i className="ri-fire-line text-accent-400" />
          {formatCount(comic.views)}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
          {comic.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">{comic.author}</p>
        {showDescription && (
          <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
            {comic.description}
          </p>
        )}
        <div className="mt-2 flex flex-wrap items-center gap-1">
          {comic.categories.slice(0, 2).map((k) => (
            <span
              key={k}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
            >
              {categoryName(k)}
            </span>
          ))}
        </div>
        <div className="mt-2.5 flex items-center justify-between border-t border-background-200/80 pt-2">
          <span className="truncate text-[11px] text-accent-700">
            更新至 第{comic.chapterCount}话
          </span>
          <span className="shrink-0 text-[11px] text-foreground-400">{comic.updatedAt}</span>
        </div>
      </div>
    </Link>
  );
}